module.exports = __webpack_public_path__ + "img/VideoCamOff.13ce3a0f.png";